module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.modalTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "sliceName"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.name),
      expression: "currentSlice.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sliceName"
    },
    domProps: {
      "value": (_vm.currentSlice.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentSlice, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "html-editor"
    }
  }, [_c('vue-html5-editor', {
    attrs: {
      "content": _vm.currentSlice.content,
      "height": 200,
      "z-index": 1000,
      "auto-height": true,
      "show-module-name": false
    },
    on: {
      "change": _vm.onChangeContent
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "html-source"
    }
  }, [_c('label', [_vm._v("HTML code only :")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.content),
      expression: "currentSlice.content"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "10"
    },
    domProps: {
      "value": (_vm.currentSlice.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentSlice, "content", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "sliceCSSClass"
    }
  }, [_vm._v("CSS Class")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.css_class),
      expression: "currentSlice.css_class"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sliceCSSClass"
    },
    domProps: {
      "value": (_vm.currentSlice.css_class)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentSlice, "css_class", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "sliceCSSStyle"
    }
  }, [_vm._v("CSS Style")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.css_style),
      expression: "currentSlice.css_style"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sliceCSSStyle"
    },
    domProps: {
      "value": (_vm.currentSlice.css_style)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentSlice, "css_style", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.visible),
      expression: "currentSlice.visible"
    }],
    attrs: {
      "type": "checkbox",
      "id": "sliceVisible"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentSlice.visible) ? _vm._i(_vm.currentSlice.visible, null) > -1 : (_vm.currentSlice.visible)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentSlice.visible,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentSlice.visible = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentSlice.visible = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentSlice, "visible", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sliceVisible"
    }
  }, [_vm._v("Visible")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.locked),
      expression: "currentSlice.locked"
    }],
    attrs: {
      "type": "checkbox",
      "id": "sliceLocked"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentSlice.locked) ? _vm._i(_vm.currentSlice.locked, null) > -1 : (_vm.currentSlice.locked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentSlice.locked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentSlice.locked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentSlice.locked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentSlice, "locked", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sliceLocked"
    }
  }, [_vm._v("Locked")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveSlice
    }
  }, [_vm._v("Save")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#html-editor"
    }
  }, [_vm._v("HTML: editor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#html-source"
    }
  }, [_vm._v("HTML: source")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b9ecdd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/back/page-edit/modal/ModalSlice.vue
// module id = 268
// module chunks = 1